/**
 * Zod validation schemas for voice transcription
 *
 * Validates audio transcription requests and responses for the
 * `transcribeAudio` Cloud Function.
 */

import { z } from 'zod';

export const TranscribeAudioRequestSchema = z.object({
  audio: z.string().max(10_000_000, 'Audio too large. Maximum 10MB (~60s).'),
  mimeType: z.enum(['audio/webm', 'audio/ogg', 'audio/mp4']),
  locale: z.literal('fi-FI'),
});
export type TranscribeAudioRequest = z.infer<typeof TranscribeAudioRequestSchema>;

export const TranscribeAudioResponseSchema = z.object({
  text: z.string(),
  latencyMs: z.number(),
});
export type TranscribeAudioResponse = z.infer<typeof TranscribeAudioResponseSchema>;
